import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'
// import { DateTime } from "luxon";


// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';
import UsageTable from './UsageTable';

import { useStore } from '../../hook-store/store';
import {
  getCustomerMeterEventSummarys, 
} from '../../utils/stripe/usage-based-billing-utils';

// import * as bucketObjectUtils from '../../../utils/bucket/bucket-object-util';
// import * as fileMoveUtils from '../../../utils/bucket/file-move-util';
// import * as objectAccessUtils from '../../../utils/bucket/object-access-util';


import {
  TEXTAUDIOTOOLSNODE_URL,
} from '../../App';

import classes from './UsageBasedBilling.module.css';


// import Grid from '@toast-ui/react-grid';
// import './tui-grid.css';

// const data = [
//   {id: 1, name: 'Editor'},
//   {id: 2, name: 'Grid'},
//   {id: 3, name: 'Chart'}
// ];

// const columns = [
//   {name: 'id', header: 'ID'},
//   {name: 'name', header: 'Name'}
// ];



function SelectPeriodUsage(props) {

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [usageList, setUsageList] = useState([]);
  const [dayDataList, setDayDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // console.log(usageBasedPrice, usageBasedSubscription)
  
  useEffect(() => {
    if (startTime > 0 && endTime > 0 && usageBasedPrice) {
      getMeterSummarysHandler(
        usageBasedPrice,
        startTime,
        endTime,
      );
    }
  },[startTime, endTime]);

  const getMeterSummarysHandler = async (price, startTime, endTime, ) => {
    try {
      if (!price || startTime === 0 || endTime === 0) {
        return;
      }

      const isData = usageList.find(usage => {
        return usage.start === startTime*1000 && usage.end === endTime*1000; 
      });

      // if (isData) {
      //   return;
      // }

      setIsLoading(true);


      const meterId = price.recurring.meter;

      const resData = await getCustomerMeterEventSummarys(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
        meterId,
        localStorage.getItem('customerId'),
        startTime,
        endTime,
      );

      console.log('getMeterSummarys resData', resData);
      
      if (resData.data) {
        if (resData.data.length >= 0) {
          // setUsageList(resData.data);

          if (!isData) {
            const addedList = usageList.concat({
              data: resData.data,
              start: startTime*1000,
              end: endTime*1000,
            });

            setUsageList(addedList);

          } else {
            const updatedList = usageList.map(usage => {
              if (usage.start === startTime*1000 && usage.end === endTime*1000) {
                return {
                  data: resData.data,
                  start: startTime*1000,
                  end: endTime*1000,
                };
              } else {
                return usage;
              }
            });

            setUsageList(updatedList);
          }
        }
      }

      setIsLoading(false);
      return resData;

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      throw err;
    }
  }


  const setThisMonthHandler = () => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    const start = new Date(startOfMonth).getTime()/1000;             
    const startOfNextMonth = new Date(now.getFullYear(), now.getMonth()+1, 1, 0, 0, 0, 0);
    const end = new Date(startOfNextMonth).getTime()/1000;
  
    setStartTime(start);
    setEndTime(end);
  };

  const setLastMonthHandler = () => {
      const now = new Date();
      const startOfLastMonth = new Date(now.getFullYear(), now.getMonth()-1, 1, 0, 0, 0, 0);
      const start = new Date(startOfLastMonth).getTime()/1000;             
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
      const end = new Date(startOfMonth).getTime()/1000;
      
      setStartTime(start);
      setEndTime(end);
  };
  
  const setThisYearHandler = () => {
    const now = new Date();
    const startOfThisYear = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
    const start = new Date(startOfThisYear).getTime()/1000;             
    const startOfNextMonth = new Date(now.getFullYear(), now.getMonth()+1, 1, 0, 0, 0, 0);
    const end = new Date(startOfNextMonth).getTime()/1000;
    
    setStartTime(start);
    setEndTime(end);
  };

  const setLastYearHandler = () => {
    const now = new Date();
    const startOfLastYear = new Date(now.getFullYear()-1, 0, 1, 0, 0, 0, 0);
    const start = new Date(startOfLastYear).getTime()/1000;             
    const startOfThisYear = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
    const end = new Date(startOfThisYear).getTime()/1000;
    
    setStartTime(start);
    setEndTime(end);
  };


  // console.log(usageList);

  // let displayList;

  // displayList = usageList.find(usage => {
  //   return usage.start === startTime*1000 && usage.end === endTime*1000; 
  // });

  // if (displayList) {
  //   displayList = displayList.data;
  // }

  // let periodTotal = 0;
  // let periodTotalUSD = 0;

  // if (usageBasedPrice && displayList) {
  //   const priceUnit = usageBasedPrice.unit_amount;

  //   for (const usage of displayList) {
  //     periodTotal = periodTotal + Number(usage.aggregated_value);
  
  //   }

  //   periodTotalUSD = priceUnit/100*periodTotal;

  // }

  let selectPeriodUsageBody;

  if (usageBasedPrice && usageBasedSubscription) {
    selectPeriodUsageBody = (
      <div>
        <div className={classes.usageBasedBillingRow}>
          <span className={classes.usageBasedBillingTitle}>
            {t('usageBased19', 'Select usage period')}
          </span>
        </div>
        <div className={classes.usageBasedBillingRow}>
          <div className={classes.usageBasedBillingButtons}>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { setThisMonthHandler() }}
            >
              {t('usageBased20', 'This month')}
            </button>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { setLastMonthHandler() }}
            >
              {t('usageBased21', 'Last month')}
            </button>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { setThisYearHandler() }}
            >
              {t('usageBased22', 'This year')}
            </button>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { setLastYearHandler() }}
            >
              {t('usageBased23', 'Last year')}
            </button>
          </div>
        </div>

        {/* {startTime && (
          <div>start-time {new Date(startTime*1000).toLocaleDateString()}</div>
        )}
        {endTime && (
          <div>end-time {new Date(endTime*1000-1).toLocaleDateString()}</div>
        )} */}
        {/* <button
          onClick={() => {
            getMeterSummarysHandler(
              usageBasedPrice,
              startTime,
              endTime,
            );
          }}
        >
          get-meter-summary
        </button> */}
        
        <div>
          {isLoading && (
            <Loader />
          )}
      {/* <div>period-total: {periodTotal} {periodTotalUSD.toFixed(2)}</div> */}



        </div>
        <UsageTable 
          startTime={startTime}
          endTime={endTime}
          usageList={usageList}
        />

        {/* <div>{JSON.stringify(usageList)}</div> */}
        {/* {JSON.stringify(usageBasedPrice)} */}
      </div>
    )
  }





  return (
    <Fragment>
      <div>{selectPeriodUsageBody}</div>
    </Fragment>
  );
}

export default SelectPeriodUsage;
